import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './helpers';
import App from './App';
import apiUrl, { apiConstants } from './constants';
import { authHeaderwithJson } from './helpers';

document.addEventListener('DOMContentLoaded', async function() {
    
    function urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - base64String.length % 4) % 4);
        const base64 = (base64String + padding)
          .replace(/\-/g, '+')
          .replace(/_/g, '/');
  
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
  
        for (let i = 0; i < rawData.length; ++i) {
          outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }
  
    const getPushSubscription = async () => {
          let registration = await navigator.serviceWorker.ready;
          let subscribeOption = {
            userVisibleOnly : true,
            applicationServerKey : urlBase64ToUint8Array('BKIosFugTzi0Kczqu8oI5ORtXh-fMU4e6iApc_CVofA0DukDg5gF18B_skkgmUV0NYXpqmqzZE6K7jDU3WrEtIA')
          }
  
          let pushSubscription = await registration.pushManager.subscribe(subscribeOption)
          return pushSubscription;
      }
    const sendSubscriptionToBackEnd = async (pushSubscription) => {
          let res = await fetch(`${apiConstants.API_URL}/pushnotification/subscribe` , {
              method : 'POST',
              headers : authHeaderwithJson(),
              body : JSON.stringify(pushSubscription)
          });
  
          console.log(res);
      }
    const geSubscription = async () => {
          let registration = await navigator.serviceWorker.ready;
          return await registration.pushManager.getSubscription();
    }

     

   
    if(! ('serviceWorker' in navigator) && ! ('PushManager' in window) ) {
        console.log("Service worker and Push aren't support");
        return;
    }

    const getNotificationPermissionState = async () => {
        if(navigator.permissions) {
            let result = await navigator.permissions.query({ name : 'notifications'})
            return result.state;
        }
    }

    
    let currentPermissionState = await getNotificationPermissionState()
    if(currentPermissionState === 'denied') {
      console.warn('the notification permission has been blocked')
     
    }
  
   

    if(currentPermissionState !== 'granted') {
      let result = await Notification.requestPermission()
      if(result !== 'granted') {
          console.log('no notification permission granted !');
          //disableNotificationBtn();
          return;
      } else {
   
          navigator.serviceWorker.ready
            .then(registration => {
              registration.showNotification('با تشکر' , {})
            })
      }
    }

  

    let subscriptionActive = await geSubscription();
    
    console.log('subscriptionActive',subscriptionActive);

    if(subscriptionActive === null) {

       
        let pushSubscription = await getPushSubscription();
        // send to server;
        console.log('pushSubscription',pushSubscription);
        console.log('push subscription sent');
        await sendSubscriptionToBackEnd(pushSubscription);
        console.log(pushSubscription)
       // deactiveNotificationBtn();
    } else {
       // subscriptionActive.unsubscribe();
       // activeNotificationBtn();
    }
    
});

ReactDOM.render(<Provider store={store}> <App /> </Provider>, document.getElementById('root'));
